import { HirerQuestionType } from '../../../__generated__/globalTypes';
import { AnswerType } from '../../sdk';
import type { StatefulRecommendedQuestion } from '../App/state';

import {
  CustomQuestionType,
  type DraftCustomQuestion,
} from './DraftCustomQuestion/DraftCustomQuestion';

const customQuestionIdLocation = (position: number): string =>
  `custom-question-${position}`;

const recommendedQuestionToCustomType = ({
  answerType,
  availableAnswers,
}: StatefulRecommendedQuestion): CustomQuestionType => {
  if (answerType === AnswerType.SingleSelect) {
    if (
      availableAnswers.length === 2 &&
      availableAnswers[0].text.toLowerCase() === 'yes' &&
      availableAnswers[1].text.toLowerCase() === 'no'
    ) {
      return CustomQuestionType.YesNo;
    }
    return CustomQuestionType.MultipleChoice;
  }

  return CustomQuestionType.FreeText;
};

const mapRecommendedQuestionToCustomQuestion = (
  question: StatefulRecommendedQuestion,
  position: number,
): DraftCustomQuestion => ({
  ...question,
  position,
  options: question.availableAnswers.map((a) => a.text),
  type: recommendedQuestionToCustomType(question),
});

const typeToQuestionType: Record<CustomQuestionType, HirerQuestionType> = {
  [CustomQuestionType.FreeText]: HirerQuestionType.FreeText,
  [CustomQuestionType.YesNo]: HirerQuestionType.SingleSelect,
  [CustomQuestionType.MultipleChoice]: HirerQuestionType.SingleSelect,
};

const customQuestionToQuestionType = (
  customQuestion: DraftCustomQuestion,
): HirerQuestionType => typeToQuestionType[customQuestion.type];

export {
  customQuestionToQuestionType,
  mapRecommendedQuestionToCustomQuestion,
  recommendedQuestionToCustomType,
  customQuestionIdLocation,
};
